<template>
    <div class="tutorial__form">
        <v-card lazy-validation>
            <v-card-title class="modal__title">
                <span class="text-h6">{{ dialogEdit ? $t('action.edit_tutorial') : $t('action.new_tutorial') }}</span>
                <button type="button" class="btn-close" @click="clickCancel">
                    <v-icon class="fa-solid fa-xmark"></v-icon>
                </button>
            </v-card-title>

            <a-form :form="form">
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <a-form-item>
                                    <label class="tutorial__label">{{ $t('form.title') }}</label>
                                    <a-input
                                        v-decorator="[
                                            'title',
                                            {
                                                initialValue: cuItem.title,
                                                rules: [{ required: true, message: $t('form.required') }],
                                            },
                                        ]"
                                        max-length="255"
                                    />
                                </a-form-item>
                            </v-col>
                            <v-col cols="12">
                                <a-form-item>
                                    <label class="tutorial__label">{{ $t('form.content') }}</label>
                                    <div class="my-2">
                                        <MyEditor :data.sync="cuItem.content" />
                                    </div>
                                    <p
                                        class="text-danger"
                                        :style="{ lineHeight: 1 }"
                                        v-if="!cuItem.content && errorObject.content"
                                    >
                                        {{ errorObject.content }}
                                    </p>
                                </a-form-item>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions class="justify-end">
                    <v-btn color="blue darken-1" text @click="clickCancel">{{ $t('cancel') }}</v-btn>
                    <v-btn color="blue darken-1" text @click="clickSave"> {{ $t('form.save') }}</v-btn>
                </v-card-actions>
            </a-form>
        </v-card>
    </div>
</template>

<script>
import MyEditor from '../MyEditor';

export default {
    components: {
        MyEditor,
    },
    props: {
        cuItem: { type: Object },
        closeCU: { type: Function },
        save: { type: Function },
        dialogEdit: { type: Boolean },
    },
    data() {
        return {
            form: this.$form.createForm(this, { name: 'tutorial-form' }),
            errorMessages: '',
            formHasErrors: false,
            errorObject: {
                content: '',
            },
        };
    },
    methods: {
        clickCancel() {
            this.closeCU();
            this.form.resetFields();
            this.errorObject = {
                content: '',
            };
        },

        clickSave(e) {
            e.preventDefault();
            let isValidEditor = true;

            if (!this.cuItem.content?.trim()) {
                this.errorObject.content = this.$t('form.required');
                isValidEditor = false;
            } else {
                this.errorObject.content = '';
            }

            this.form.validateFields((err, values) => {
                if (!err && isValidEditor) {
                    const body = {
                        ...this.cuItem,
                        title: values.title.trim(),
                        type: 'FUNCTION',
                    };
                    this.save(body, (isSuccess) => {
                        if (isSuccess) this.clickCancel();
                    });
                }
            });
        },
    },
};
</script>

<style lang="scss">
.tutorial__form {
    & .ant-form-item {
        margin-bottom: 0;
    }
}

.tutorial__label {
    display: block;
    margin-bottom: 5px;
    line-height: 1;
}

.modal__title {
    display: flex;
    justify-content: space-between;
    line-height: 1;
    & .btn-close i {
        color: #aaa !important;
        transition: all 0.4s ease;
    }
    & .btn-close:hover i {
        color: #000 !important;
    }
}
</style>
